import Button from '@carvana/ds-button';
import { ChevronRight } from 'lucide-react';
import React from 'react';
import styles from './mobile-vehicle-card.module.css';
import {
  financeTotalLabel,
  formatCurrency,
  getNonFinanceLabel
} from '../vehicle-card/vehicle-card-helpers';
import type { VehicleSummary } from '../vehicle-card/vehicle-card';

interface MobileVehicleCardProps {
  summary: VehicleSummary;
  onViewOrderDetails?: () => void;
}

const MobileVehicleCard: React.FC<MobileVehicleCardProps> = ({ summary, onViewOrderDetails }) => {
  const { imageUrl, year, make, model, trim, purchaseType, monthlyPayment, cashDue } = summary;

  const totalDisplay =
    purchaseType === 'finance' ? financeTotalLabel(cashDue ?? 0) : getNonFinanceLabel(summary);

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.summary}>
          <div className={styles.mediaWrap}>
            <img src={imageUrl} alt={`${year} ${make} ${model}`} className={styles.media} />
          </div>
          <div className={styles.ymmt}>
            <p className={styles.vehicleName}>
              {year} {make} {model}
            </p>
            <p className={styles.trimText}>{trim}</p>
          </div>
        </div>

        <div className={styles.priceDetails}>
          <div className={styles.purchaseStats}>
            {purchaseType === 'finance' && (
              <div className={styles.statStacked}>
                <span className={styles.statStackedLabel}>Payment</span>
                <div className={styles.statStackedAmountInline}>
                  <span className={styles.statStackedAmount}>
                    {formatCurrency(monthlyPayment ?? 0)}
                  </span>
                  <span className={styles.statStackedAmountSuffix}>/mo</span>
                </div>
              </div>
            )}
            <div className={styles.statStacked}>
              <span className={styles.statStackedLabel}>{totalDisplay.label}</span>
              <span className={styles.statStackedAmount}>
                {formatCurrency(totalDisplay.amount)}
              </span>
            </div>
          </div>
          <Button
            className={styles.reviewOrderButton}
            size="xs"
            variant="secondary"
            utility
            onClick={onViewOrderDetails}
            data-analytics-id="checkout-mobile-vehicle-card-review-order"
          >
            Review order <ChevronRight size={16} color="currentColor" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileVehicleCard;
